module.exports = __webpack_public_path__ + "img/mailing-list.34908207.svg";